export function extractTempKeysFromHtml(html: string): string[] {
  const tempKeys: string[] = [];
  const imgSrcRegex = /#tempKey=([^"'\s]+)/g;
  let match;
  while ((match = imgSrcRegex.exec(html)) !== null) {
    // `match[1]` exists whenever the regex matched; the `| undefined` is noUncheckedIndexedAccess.
    tempKeys.push(match[1]!);
  }
  return tempKeys;
}

export function replaceBase64WithTempKeys(html: string, urlFormatter: (tempKey: string) => string): string {
  return html.replace(
    /src="data:[^"]*#tempKey=([^"]+)"/g,
    (_, tempKey) => `src="${urlFormatter(tempKey)}"`,
  );
}
